<template>
  <div>
    <vue-hcaptcha
      ref="captcha"
      :sitekey="key_captcha"
      @verify="handleVerify"
      @expired="handleExpired"
      @error="handleError"
      :theme="theme"
    />
  </div>
</template>

<script>
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
import { key_captcha } from '../../../.env.js';

export default {
  name: 'Hcaptcha',
  components: {
    VueHcaptcha
  },
  props: {
    theme: {
      type: String,
      default: 'light'
    }
  },
  data: () => ({
    key_captcha
  }),
  methods: {
    handleVerify(token) {
      this.$emit('verified', token);
    },
    handleExpired() {
      this.$emit('expired');
    },
    handleError() {
      this.$emit('error');
    },
    execute() {
      this.$refs.captcha.execute();
    },
    reset() {
      console.log(this.key_captcha, 'key_captcha')
      this.$refs.captcha.resetCaptcha();
    }
  }
};
</script>
